import { usersService } from "../../api/users";

export const GET_DATA = "GET_USERS";
export const ADD = "ADD_USER";
export const UPDATE = "UPDATE_USER";
export const DELETE = "DELETE_USER";
export const SET_INITIALIZED_DATA = "SET_INITIALIZED_DATA_USERS";
export const ADD_SELECTED_ROW = "ADD_SELECTED_ROW_USER";
export const DELETE_SELECTED_ROW = "DELETE_SELECTED_ROW_USER";
export const SET_SELECTED_ROWS = "SET_SELECTED_ROWS_USER";
export const SET_FILTERS = "SET_FILTERS_USERS";
export const SET_SORTERS = "SET_SORTERS_USERS";

export function getData() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      usersService.getData().then(
        (response) => {
          dispatch({ type: GET_DATA, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function get(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      usersService.get(id).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function add(form) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      usersService.add(form).then(
        (response) => {
          dispatch({ type: ADD, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function update(id, form) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      usersService.update(id, form).then(
        (response) => {
          dispatch({ type: UPDATE, id, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      usersService.delete(id).then(
        (response) => {
          dispatch({ type: DELETE, id });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function setInitializedData(value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_INITIALIZED_DATA, payload: value });
      resolve();
    });
  };
}

export function addSelectedRow(record) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: ADD_SELECTED_ROW, payload: record });
      resolve();
    });
  };
}

export function removeSelectedRow(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: DELETE_SELECTED_ROW, id });
      resolve();
    });
  };
}

export function setSelectedRows(records) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_SELECTED_ROWS, payload: records });
      resolve();
    });
  };
}

export function setFilters(value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_FILTERS, payload: value });
      resolve();
    });
  };
}

export function setSorters(value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_SORTERS, payload: value });
      resolve();
    });
  };
}
